import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip, Box } from '@mui/material';
import { appointmentTypesFields } from '../../appointment-types.model';

/**
 * Custom field to display contact types as chips
 */
const ContactTypesField = ({ 
    source = appointmentTypesFields.availableContactTypes,
    label = 'Contact Types',
    sortable = false,
    addLabel = true,
}) => {
    const record = useRecordContext();
    
    if (!record) {
        return null;
    }
    
    const contactTypes = record[source];
    
    if (!contactTypes || !Array.isArray(contactTypes) || contactTypes.length === 0) {
        return <span>-</span>;
    }
    
    return (
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            {contactTypes.map((type, index) => (
                <Chip 
                    key={index}
                    label={type}
                    size="small" 
                    color="primary"
                    variant="outlined"
                />
            ))}
        </Box>
    );
};

export default ContactTypesField;

